import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../../ReactQuery/useQuery';
import { get } from '../../../../redux/api';
import type { FullTeamGroupResponse } from '../../../../../shared/types/routes/teamGroups';

//  Actual function to fetch a team group
function fetchTeamGroup(id: number) {
  return get<FullTeamGroupResponse>(`/api/teams/groups/${id}`);
}

/**
 * This is used by react-query for caching and invalidation.
 * This can contain anything (including objects like filters)
 * that can be used to uniquely identify the query.
 *
 * Note that since this will be serialized anyway, we cast the id to a string.
 */
export const getTeamGroupQueryKey = (id: number | string): QueryKey => ['teams', 'groups', id?.toString() ?? id];

/**
 * useTeamGroup is a hook that fetches and returns the team group with the given id.
 */
export default function useTeamGroup(id: number) {
  return useQuery<FullTeamGroupResponse>({
    queryKey: getTeamGroupQueryKey(id),
    queryFn: () => fetchTeamGroup(id),
  });
}
